import { months } from "../../../../../../Utils/months";

const validate = (values) => {
    const errors = {};
    const salesData = (values && values.sales_data) || [];

    // Crea un arreglo paralelo para los errores
    const salesErrors = [];

    for (let i = 0; i < salesData.length; i++) {
        const item = salesData[i];
        const itemErrors = {};

        for (let j = 0; j < months.length; j++) {
            const mes = months[j];
            const rawValue = item && item[mes];

            if (rawValue !== undefined && rawValue !== null && rawValue !== '') {
                const valor = parseFloat(rawValue);
                if (!isNaN(valor) && valor < 0) {
                    itemErrors[mes] = 'No se permiten valores negativos';
                }
            }
        }

        if (Object.keys(itemErrors).length > 0) {
            salesErrors[i] = itemErrors;
        }
    }

    if (salesErrors.length > 0) {
        errors.sales_data = salesErrors;
    }

    return errors;
};

export default validate